// this file is automatically generated by git.version.ts script
export const versionInfo = {
  version: '1.0.0',
  revision: '049b6e4',
  branch: 'HEAD'
};